exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-anim-duration-select-wrOxR{padding:8px 10px;border-radius:,4px;border-radius:var(---,4px);background:#fff;background:var(--TDoc-Light-Background-Level-4-bg-lv4-default,#fff);box-shadow:0 6px 32px 2px rgba(0,0,0,.16),0 4px 6px 2px rgba(0,0,0,.04),0 0 0 1px rgba(0,0,0,.04);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}", ""]);

// Exports
exports.locals = {
	"anim-duration-select": "index-anim-duration-select-wrOxR"
};